import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import { useNotify } from 'react-admin';

import { uploadAndCreateAttachment } from '@src/services/api/attachments';
import { file2Attachment } from './utils';

import Dropzone from './attachment-dropzone';

const StyledRoot = styled('div')({
    position: 'relative',
});

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
    color: '#fff',
    zIndex: theme?.zIndex?.drawer ? theme.zIndex.drawer + 1 : 1301,
    position: 'absolute',
}));

const AttachmentUploader = (props) => {
    const { accept, multiple = true, onAttachmentsAdded } = props;

    const [uploading, setUploading] = useState(false);
    const notify = useNotify();

    const handleFileSelection = useCallback((selectedFiles) => {
        setUploading(true);
        const attachments = selectedFiles.map(file2Attachment);

        Promise.all(attachments.map(uploadAndCreateAttachment))
            .then((createdAttachments) => {
                onAttachmentsAdded(createdAttachments);
                setUploading(false);
            }).catch((e) => {
                notify(`Error on uploading files: ${e.message}`, 'error');
                setUploading(false);
            });
    }, [setUploading, onAttachmentsAdded, notify]);

    return (
        <StyledRoot>
            <Dropzone accept={accept} multiple={multiple} onFileSelected={handleFileSelection} />
            <StyledBackdrop open={uploading}>
                <CircularProgress color="inherit" />
            </StyledBackdrop>
        </StyledRoot>
    );
};

AttachmentUploader.propTypes = {
    accept: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    multiple: PropTypes.bool,
    onAttachmentsAdded: PropTypes.func.isRequired,
};

export default AttachmentUploader;
